import { CustomerCaseStatus, CaseStatus } from '@/api/apis/case';
import { customerCaseStatusNames, caseStatusNames } from '@/constants/case/case.constants';
import { TrackingCardState } from './types';

const CUSTOMER_CASE_UNAVAILABLE_STATUSES: CustomerCaseStatus[] = [
  CustomerCaseStatus.TransplantNotCompleted,
  CustomerCaseStatus.OrganOffOCS,
  CustomerCaseStatus.NOPServiceCompleted,
  CustomerCaseStatus.NOPInvoiceReceived,
  CustomerCaseStatus.CaseClosed,
];

export const resolveCustomerCaseTrackingConfig = (
  status: CustomerCaseStatus,
  isEnabled: boolean,
): { cardState: TrackingCardState; title: string } => {
  let cardState: TrackingCardState;

  if (!isEnabled || CUSTOMER_CASE_UNAVAILABLE_STATUSES.includes(status)) {
    cardState = TrackingCardState.Unavailable;
  } else if (status === CustomerCaseStatus.OrganInTransit) {
    cardState = TrackingCardState.InTransit;
  } else if (status === CustomerCaseStatus.OrganAtTXCenter) {
    cardState = TrackingCardState.AtTxCenter;
  } else {
    cardState = TrackingCardState.Default;
  }

  const title =
    cardState === TrackingCardState.Default
      ? 'Location tracking is not yet available'
      : customerCaseStatusNames[status];

  return { cardState, title };
};

const CASE_STATUS_UNAVAILABLE: CaseStatus[] = [
  CaseStatus.OrganOffOCS,
  CaseStatus.ServiceCompleted,
  CaseStatus.ServiceDeclined,
  CaseStatus.ReturningToBase,
  CaseStatus.Finished,
  CaseStatus.Closed,
];

export const resolveCaseStatusTrackingConfig = (
  status: CaseStatus,
  isNonTmdxLogistics = false,
): { cardState: TrackingCardState; title: string } => {
  let cardState: TrackingCardState;

  if (isNonTmdxLogistics) {
    cardState = TrackingCardState.NonTmdxLogistics;
  } else if (CASE_STATUS_UNAVAILABLE.includes(status)) {
    cardState = TrackingCardState.Unavailable;
  } else if (status === CaseStatus.DeployedToTXCenter) {
    cardState = TrackingCardState.InTransit;
  } else if (status === CaseStatus.AtTXCenter) {
    cardState = TrackingCardState.AtTxCenter;
  } else {
    cardState = TrackingCardState.Default;
  }

  const title =
    cardState === TrackingCardState.Default ? 'Location tracking is not yet available' : caseStatusNames[status];

  return { cardState, title };
};
